import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { Button } from './UI';
import { store } from '../stores/mainStore';

const BlurPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	pointer-events: auto;
	font-size: 32px;
`

const Content = styled.div`
	display: block;
	width: 100%;
	text-align: center;
	line-height: 60px;
`

export class ModalBlur extends Component {

	continue(){
		store.modal = '';
	}
	render() {
		return (
			<BlurPage>
				<Content>
					Paused<br/>
					<Button continue onClick={this.continue}/>
				</Content>
			</BlurPage>
		)
	}
}